module.exports = __webpack_public_path__ + "img/key-old.2f6d8007.svg";